<template>
  <AlertMessage v-if="status" type="warning" :message="status" class="mb-4" />
</template>

<script>
import { requestMixin } from '../../mixins/request/request';
import AlertMessage from '../base/AlertMessage.vue';

export default {
  mixins: [requestMixin],
  components: { AlertMessage },
  props: {
    orderId: {
      required: true,
      type: String,
    },
  },
  data() {
    return {
      status: null,
    };
  },
  methods: {
    async loadStatus() {
      const [res, err] = await this.request(
        `/api/v1/orders/${this.orderId}/-actions/check-promo-updated-status`
      );

      if (!err) {
        this.status = res;
      }
    },
  },
  created() {
    this.loadStatus();
  },
};
</script>
